import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const posts = [
  { title: '5 SEO Trends for 2024', summary: 'Stay ahead with the latest SEO strategies for the coming year.', date: '2024-05-01' },
  { title: 'How to Build a Social Media Calendar', summary: 'Organize your content and boost engagement with a solid plan.', date: '2024-04-15' },
  { title: 'Why Video Marketing Works', summary: 'Discover the power of video for brand growth.', date: '2024-03-28' },
];

const Blog = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-3xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <motion.h1
        className="text-4xl font-bold text-brand-blue mb-6 text-center"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        Blog & Insights
      </motion.h1>
      <div className="space-y-8">
        {posts.map((p, i) => (
          <motion.div
            key={i}
            className="bg-blue-50 rounded-lg p-6 shadow mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.2, ease: 'easeOut' }}
          >
            <h2 className="text-xl font-bold text-brand-blue mb-2">{p.title}</h2>
            <p className="text-gray-800 mb-2">{p.summary}</p>
            <p className="text-gray-500 text-sm">{p.date}</p>
          </motion.div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default Blog; 